<template>
  <div
    v-if="store.loadedConfig"
    class="page__sidebar h-100"
  >
    <component
      :is="sideBar"
      :not-read="notRead"
      :drafts="drafts"
      :issues="issues"
      :view-all-allowed="viewAllAllowed"
      :view-all-enabled="viewAllEnabled"
      :is-grossing="true"
      :counters="allCounters"
      :options="options"
      :selected-option="selectedOption"
      :store="store"
      :disable-add-filter="disableAddFilter"
      :custom-options="customOptions"
      @expand="expand"
      @setDefaultOptionParent="setDefaultOption($event)"
      @view-all-toggled="setViewAll($event)"
      @contract="contract"
      @update:selected-option="changeSelectedOption"
      @click-add-filter="$emit('click-add-filter')"
      @remove-option="removeCustomOption"
      @update-option="showUpdateModal"
      @rename-option="showRenameModal"
    />
    <modal-confirmation
      id="grossingSideBarConfirmationModal"
      ref="confirmationModal"
    />
    <rename-custom-filter-modal
      id="renameCustomFilterModal"
      ref="renameModal"
      @ok="renameCustomOption"
    />
  </div>
</template>

<script>
import Vue from 'vue'
import store from './grossingSideBarStore'
import ModalConfirmation from '@/components/modals/ModalConfirmation'
import RenameCustomFilterModal from '@/components/customFilter/RenameCustomFilterModal'
import { SampleOperationGuardMixin } from '@/api/operations/mixins/guards/sample-operation-guard.mixin'

export default {
    name: 'GrossingSideBar',
    components: {
        ModalConfirmation,
        RenameCustomFilterModal
    },
    mixins: [
        SampleOperationGuardMixin
    ],
    props: {
        counters: { type: Object } // a map containing the numbers for each badge
    },
    data() {
        return {
            store: store,
            state: store.state
        }
    },
    computed: {
        sideBar() {
            return this.state.sideBar
        },
        customOptions() {
            return this.state.customOptions
        },
        options() {
            return this.state.options
        },
        selectedOption() {
            return this.state.selectedOption
        },
        disableAddFilter() {
            return this.gridRouteName !== this.$route.name
        },
        gridRouteName() {
            return this.state.gridRouteName
        },
        notRead() {
            return this.counters?.requestsWithReportNotReaded
        },
        drafts() {
            return this.counters?.draftRequests
        },
        issues() {
            return this.counters?.requestsWithIssue
        },
        allCounters() {
            return this.counters
        },
        viewAllAllowed() {
            return this.$_canViewAllProcess()
        },
        viewAllEnabled() {
            return this.state.config.viewAllEnabled
        }
    },
    methods: {
        showUpdateModal(option) {
            this.$refs.confirmationModal.ask(() => {
                this.$emit('update-option', option)
            })
        },
        changeSelectedOption(value) {
            store.setSelectedOption(value)
            this.$router.push({ name: this.gridRouteName })
            this.$emit('changed-option', value)
        },
        selectDefaultOption() {
            store.selectDefaultOption()
            this.$emit('changed-option', this.state.selectedOption)
        },
        removeCustomOption(option) {
            this.$refs.confirmationModal.ask(() => {
                store.removeCustomOption(option)
                this.$_showToastSuccess(this.$tc('global.filterDeleted'))
            })
        },
        showRenameModal(option) {
            this.$refs.renameModal.show(option)
        },
        renameCustomOption(option) {
            store.renameCustomOption(option)
            this.$_showToastSuccess(this.$tc('global.renamedFilter'))
        },
        async expand() {
            await store.expandSideBar()
            Vue.nextTick(() => { this.$emit('changed-width') })
        },
        async contract() {
            await store.contractSideBar()
            Vue.nextTick(() => { this.$emit('changed-width') })
        },
        async setDefaultOption(ev) {
            store.setDefaultOption(ev)
            await store.saveConfig()
        },
        async setViewAll(ev) {
            store.setViewAll(ev)
            await store.saveConfig()
            this.$emit('view-all-toggled', ev)
        }
    }
}

</script>
